import Header from "./Header";
import Controls from "./Controls";
import TabArea from "./TabArea";

const Form = ({
  translatedGender,
  docsPerKindFiltered,
  error,
  setError,
  applicationKinds,
  port_auth,
  disableAll,
}) => {
  return (
    <>
      <Header
        error={error}
        setError={setError}
        applicationKinds={applicationKinds}
        port_auth={port_auth}
      />
      <Controls disabledSubmitButton={!!error} />

      <TabArea
        disableAll={disableAll}
        docsPerKindFiltered={docsPerKindFiltered}
        translatedGender={translatedGender}
      />
    </>
  );
};

export default Form;
